import React from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';

import { useClientContext } from '@client/lib/ClientContext';

import { cnMap } from './Map.const';
import type { IMapProps } from './Map.typings';

// eslint-disable-next-line import-x/order
import 'leaflet/dist/leaflet.css';
// eslint-disable-next-line import-x/order
import '@changey/react-leaflet-markercluster/dist/styles.min.css';
import './Map.scss';

export const Map: React.FC<IMapProps> = props => {
    const [{ lang }] = useClientContext();

    const url = `https://mt{s}.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga&hl=${lang}`;
    const copyright = '&copy; <a href="https://google.com/maps">Google Maps</a>';

    return (
        <MapContainer
            {...props}
            className={cnMap(null, [props.className])}
        >
            <TileLayer
                url={url}
                attribution={copyright}
                subdomains="012"
            />
            {props.children}
        </MapContainer>
    );
};
